import { doesWorkflowRejectCodeExist } from '@tassat/common-definitions';
import { IFormValues } from '@tassat/forms/src/UserWalletMappingForm/types';
import { UserAccountRecord } from '@tassat/payments-definitions';

import Worker from 'Lib/worker/PrimusWorkerWrapper';

export const submitUserWalletMappingForm = async (values: IFormValues, opts: {
    userId: string;
    setSubmitError: React.Dispatch<React.SetStateAction<string>>;
    onClose: () => void;
}): Promise<void> => {
    const {
        setSubmitError,
        onClose
    } = opts;

    const errors = [];
    try {
        values.Mappings.forEach(async (mapping) => {
            let response;

            if (Object.keys(mapping.Wallet.refData.userAccount || {} as UserAccountRecord).length > 0){
                response = await Worker.getInstance()
                    .updateUserAccount({
                        UserId: mapping.Wallet.refData.user.UserId,
                        AccountId: mapping.Wallet.value,
                        ClientRoleId: mapping.Role,
                        WireRoleId: mapping.Wallet.refData.userAccount.WireRoleId,
                        UserAccountId: mapping.Wallet.refData.userAccount.UserAccountId,
                        IsFavorite: mapping.Wallet.refData.userAccount.Isfavorite,
                        IsDeleted: mapping.Wallet.refData.userAccount.IsDeleted
                    });
            } else {
                response = await Worker.getInstance()
                    .createUserAccount({
                        UserId: mapping.Wallet.refData.user.UserId,
                        AccountId: mapping.Wallet.value,
                        ClientRoleId: mapping.Role
                    });
            }

            if (response.data && response.data.Status === 49 || doesWorkflowRejectCodeExist(response.data.Status)) {
                errors.push(mapping.Wallet.label);
            }
        });

        if (errors.length > 0) {
            setSubmitError(`Could not map user to account(s): ${errors.join(', ')}`);
        } else {
            onClose();
        }
    } catch (error) {
        setSubmitError('Something went wrong');
    }
};